import { tryCatch } from '@libs/core';

export type Severity = 'success' | 'warning' | 'error';
export type Decoded = Record<'headers' | 'cookies' | 'search', ReadonlyMap<string, string>>;

export interface FlagIssue {
    severity: Exclude<Severity, 'success'>;
    rule: string;
}

export function validateFlags(flags: ReadonlyMap<string, string>) {
    const issues = new Map<string, FlagIssue>();

    flags.forEach((_, key) => {
        if (key.startsWith('ff_')) issues.set(key, { severity: 'warning', rule: 'ff_ prefix' });
        if (key.startsWith('exp_')) issues.set(key, { severity: 'warning', rule: 'exp_ prefix' });
        if (key.length > 15) issues.set(key, { severity: 'error', rule: '> 15 chars' });
    });

    const all = Array.from(issues.values());
    const errors = all.filter(i => i.severity === 'error').length;
    const warnings = all.length - errors;
    const severity: Severity = errors ? 'error' : warnings ? 'warning' : 'success';

    return { severity, issues, errors, warnings };
}

export function preview(data: ReadonlyMap<string, string>, max = 2) {
    const keys = Array.from(data.keys());
    const rest = keys.length - max;
    const head = keys.slice(0, max).join(', ');

    if (!keys.length) return 'No items';
    return rest ? `${head}, +${rest}` : head;
}

export function flags({ cookies }: Decoded) {
    const [, decisions] = tryCatch(() => JSON.parse(cookies.get('x-petm-decisions') ?? '{}'));

    return new Map(Object.entries(decisions ?? {}).map(([k, v]) => [k, String(v)] as const));
}
